import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet';  // Import Helmet for SEO
import ChildGuidanceImg from '../img/career2.png'; // Replace with a relevant image for Child Guidance

const Child_Guidance = () => {
    const cardData = [
        {
            id: 1,
            title: 'Positive Reinforcement',
            text: 'Positive reinforcement involves rewarding desirable behavior to encourage its recurrence. This method is commonly used in child guidance to promote good habits, like completing tasks, displaying positive social interactions, and demonstrating academic effort. Rewards can include praise, stickers, or small treats.',
        },
        {
            id: 2,
            title: 'Behavioral Management Techniques',
            text: 'Behavioral management techniques aim to reduce undesirable behaviors and promote self-control. This may include strategies like time-outs, creating behavior charts, or setting clear and consistent expectations. These techniques help children develop discipline and understand the consequences of their actions.',
        },
        {
            id: 3,
            title: 'Cognitive-Behavioral Techniques for Children',
            text: 'Cognitive-behavioral techniques for children focus on teaching children how to recognize and change negative thought patterns that contribute to anxiety, fear, and poor behavior. Techniques such as thought-stopping, problem-solving, and relaxation exercises are often used to help children manage emotions and make better choices.',
        },
        {
            id: 4,
            title: 'Parental Guidance and Training',
            text: 'Parental guidance and training is an essential part of child development. It involves helping parents understand their child’s needs, temperament, and behavior. Parents are taught effective strategies for setting boundaries, providing emotional support, and fostering a positive home environment for their child.',
        },
        {
            id: 5,
            title: 'Social Skills Training',
            text: 'Social skills training helps children develop the ability to interact appropriately with peers, adults, and in social settings. Skills such as sharing, turn-taking, active listening, and conflict resolution are emphasized. This training is beneficial for children with social anxiety, autism, or other behavioral challenges.',
        },
        {
            id: 6,
            title: 'Play Therapy',
            text: 'Play therapy is a therapeutic technique where children use play to express their thoughts, emotions, and experiences. It is particularly effective for younger children who may not yet have the vocabulary to express themselves verbally. Through play, children can work through emotional issues, develop coping skills, and enhance their self-esteem.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>Child Guidance and Support | Positive Reinforcement & Behavioral Techniques</title>
                <meta name="description" content="Child guidance focuses on nurturing a child's social, emotional, and cognitive development. Learn about positive reinforcement, social skills training, and play therapy techniques that help children thrive." />
                <meta name="keywords" content="Child Guidance, Positive Reinforcement, Behavioral Techniques, Cognitive Behavioral Therapy for Children, Parental Training, Social Skills, Play Therapy" />
                <meta name="author" content="Your Company Name" />
                <meta property="og:title" content="Child Guidance and Support | Positive Reinforcement & Behavioral Techniques" />
                <meta property="og:description" content="Explore child guidance strategies to support your child's emotional, social, and cognitive growth. Learn effective techniques for parenting, behavior management, and therapy." />
                <meta property="og:image" content={ChildGuidanceImg} />
                <meta property="og:url" content="https://yourwebsite.com/child-guidance" />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <img src={ChildGuidanceImg} alt="Child Guidance" className="img-fluid h-100 w-100 rounded-md"/>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <h1 style={{fontFamily:'monospace'}} className='mb-4'>Child Guidance and Support</h1>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Child guidance focuses on nurturing a child’s development through supportive strategies and techniques. It aims to enhance social, emotional, and cognitive growth while addressing behavioral concerns. Early intervention and structured guidance can significantly impact a child’s ability to thrive academically, socially, and emotionally.</p>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>By providing children with positive role models, clear expectations, and opportunities to express themselves, child guidance helps build a foundation for healthy, well-adjusted individuals.</p>
                    </Col>
                </Row>
            </Container>

            <Container className='mb-5'>
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className='bg-info-subtle'>
                                <Card.Body>
                                    <Card.Title style={{color:'#093c60'}} className=' fw-bold'>{card.title}</Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Child_Guidance;
